// API route → server cache key(s) whose `feed` stream events should make a
// useFeed() instance refetch. The keys are the first argument of `cached(…)`
// in apps/api/src/adapters/*; a route that aggregates several feeds lists all
// of them. Keep in sync with the adapters — feedKeys.test.ts fails when App.tsx
// polls a path that is neither mapped here nor listed in STREAMLESS_PATHS.

export const FEED_KEYS: Readonly<Record<string, readonly string[]>> = {
  "/api/incidents/city-reports": ["city-reports"],
  "/api/incidents/itic": ["itic"],
  "/api/news": ["news"],
  "/api/weather": ["weather:v3"],
  "/api/weather/series": ["weather-series:v1"],
  "/api/air-quality": ["air-quality:v3"],
  "/api/air-quality/stations": ["air-quality-stations:v3"],
  "/api/air-quality/trend": ["air-quality-trend:v3"],
  "/api/air-quality/airdash": ["airdash-stations"],
  "/api/cctv/longdo": ["cctv-longdo"],
  "/api/transit/cu-shuttle": ["cu-shuttle"],
  // /api/executive is computed per request from these four cached feeds.
  "/api/executive": ["air-quality:v3", "city-reports", "itic", "news"],
  "/api/precip-nowcast": ["precip-nowcast:v3"],
  "/api/traffic/corridors": ["corridor-model"],
  "/api/academic-calendar": ["academic-calendar"],
  "/api/flood/watch": ["bkk-flood-watch"],
  "/api/flood/gauges": ["thaiwater-bkk-gauges"],
  "/api/flood/rain": ["thaiwater-bkk-rain"],
  "/api/flood/canals": ["thaiwater-canals-campus-v3"],
  "/api/flood/campus-stations": ["flood-campus-stations"],
  "/api/flood/campus-events": ["flood-campus-events"],
  "/api/flood/prevention": ["flood-campus-prevention"],
  "/api/flood/verification": ["flood-dash-verification:v1"],
  "/api/bma/pois": ["bma-pois"],
  "/api/bma/datasets": ["bma-ckan"],
  "/api/forecast": ["precip-forecast:timefm:v1"],
};

/**
 * Paths deliberately without stream notifications (polling only). Empty
 * today; add a path here with a reason rather than leaving it unmapped.
 */
export const STREAMLESS_PATHS: ReadonlySet<string> = new Set<string>();

/** Strip origin/API base and query string: "https://x/api/news?_=1" → "/api/news". */
export function normalizeApiPath(pathOrUrl: string): string {
  let p = pathOrUrl;
  const apiIdx = p.indexOf("/api/");
  if (apiIdx > 0) p = p.slice(apiIdx);
  const q = p.search(/[?#]/);
  if (q >= 0) p = p.slice(0, q);
  return p.replace(/\/+$/, "");
}

/** Cache keys for a useFeed path (with or without API base); [] if none. */
export function feedKeysForPath(pathOrUrl: string): readonly string[] {
  return FEED_KEYS[normalizeApiPath(pathOrUrl)] ?? [];
}
